var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-date-time" },
    [
      _c("AutomationWizardFieldDate", {
        attrs: { field: _vm.dayField, value: _vm.dayValue },
        on: { "update:value": _vm.handleDayUpdate }
      }),
      _vm._v(" "),
      _c("AutomationWizardFieldTime", {
        attrs: { field: _vm.timeField, value: _vm.timeValue },
        on: { "update:value": _vm.handleTimeUpdate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }